import { render, staticRenderFns } from "./UpdateProjectLogDisputeModal.vue?vue&type=template&id=c00c2760&"
import script from "./UpdateProjectLogDisputeModal.vue?vue&type=script&lang=js&"
export * from "./UpdateProjectLogDisputeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports